import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Optional
} from '@angular/core';
import { InkFormData, InkStroke } from '@authority-labs/api-interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InspectionDataService } from '../../inspection-data.service';
import { generateSvgPath } from '../../inspection-draft/utils/svg-path.util';

@Component({
  selector: 'authority-labs-draft-field-indicator',
  templateUrl: './draft-field-indicator.component.html',
  styleUrls: ['./draft-field-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DraftFieldIndicatorComponent implements OnInit, OnDestroy {
  @Input() fieldId: string;
  @Input() inkFormData: InkFormData;

  popoverVisible = false;
  private serviceInkData: InkFormData;
  private destroy$ = new Subject<void>();

  getSvgPath = generateSvgPath;

  constructor(
    private cdr: ChangeDetectorRef,
    @Optional() private inspectionDataService: InspectionDataService
  ) {}

  ngOnInit(): void {
    if (!this.inkFormData && this.inspectionDataService) {
      this.inspectionDataService.draftInkData$
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.serviceInkData = data;
          this.cdr.markForCheck();
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get strokes(): InkStroke[] {
    const data = this.inkFormData || this.serviceInkData;
    if (!data?.fields || !this.fieldId) {
      return null;
    }
    const fieldData = data.fields[this.fieldId];
    return fieldData?.strokes?.length ? fieldData.strokes : null;
  }
}
